// Local Imports
import ContractBuilder from '../contractbuilder/ContractBuilder.js';

function OpportunityContractBuilder(props) {
    const { 
        offers, setOffers, routes, products, org, minimizedSearch, setMinimizedSearch,
        seaPorts, unlocode, transportationMethod, status, onCreateTemplate, owner, me, errors,
        buyingRates, setBuyingRates, suppliers, accesstoken, exchangeRates
    } = props;

    return (
        <ContractBuilder
            mode={'opportunities'}
            org={org}
            routes={routes}
            transportationMethod={transportationMethod}
            offers={offers}
            products={products}
            setOffers={setOffers}
            seaPorts={seaPorts}
            unlocode={unlocode}
            onCreateTemplate={onCreateTemplate}
            buyingRates={buyingRates}
            setBuyingRates={setBuyingRates}
            suppliers={suppliers}
            accesstoken={accesstoken}
            minimizedSearch={minimizedSearch}
            setMinimizedSearch={setMinimizedSearch}
            exchangeRates={exchangeRates}
        />
    )
}

export default OpportunityContractBuilder;
